import React from "react";
import { NavLink } from "react-router-dom";
// import logoImg from "../logo.svg";
// import { Icon } from "react-icons-kit";
// import { menu } from "react-icons-kit/feather/menu";
// import { arrowLeft } from "react-icons-kit/feather/arrowLeft";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
// import axios from "axios";
import Select from "react-select";
import Sidebar from "../components/Sidebar";
import { useJwt } from "react-jwt";
import {
  GetProductById,
  GetProductCatWithoutPage,
  GetProductStatus,
  GetProductSubCatWithoutPage,
  UpdateProduct,
  getallbrandnamewithoutpagination,
  getAllTags,
} from "../apiconfig/authService";

function EditProduct(props) {
  const navigate = useNavigate();
  const { _, isExpired } = useJwt(localStorage.getItem("accessToken"));
  if (isExpired) navigate("/");

  const setCategoryViewMessage = props.setMessage;

  const [productData, setProductData] = useState({});
  const [editedProductData, setEditedProductData] = useState({});
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [message, setMessage] = useState("");
  const [isMessageRed, setIsMessageRed] = useState(false);
  const { productid } = useParams();
  const [visibleSubcategories, setVisibleSubcategories] = useState([]);
  // const [newImage, setNewImage] = useState(null);
  const [statusData, setStatusData] = useState([]);
  // const imageInputRef = React.createRef();
  const [brands, setBrands] = useState([]);
  const [allTags, setAllTags] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [search, setSearch] = useState("");
  const itemsPerPage = 500;
  // const [selectedBrand, setSelectedBrand] = useState("");
  // const [isbestsellerstitle, setIsbestSellersTitle] = useState("");

  // const handleIsbestSellersTitleOnChange = (e) => {
  //   const temp = { ...editedProductData };
  //   temp._doc.isbestsellerstitle = e.target.value;
  //   setEditedProductData(temp);
  // };

  useEffect(() => {
    (async () => {
      try {
        const response = await GetProductById(
          productid,
          localStorage.getItem("accessToken")
        );
        setProductData(response.data.product);
        setEditedProductData(response.data.product);
        const categoryResponse = await GetProductCatWithoutPage(
          localStorage.getItem("accessToken")
        );
        const subCategoryResponse = await GetProductSubCatWithoutPage(
          localStorage.getItem("accessToken")
        );
        const brandResponse = await getallbrandnamewithoutpagination();
        setCategories(categoryResponse.data.categories);
        setSubcategories(subCategoryResponse.data.subcategories);
        setBrands(brandResponse.data);
        // console.log(
        // subCategoryResponse.data.subcategories.filter(item => item.categoryid==response.data?.product?._doc?.categoryids[0])
        // );
        setVisibleSubcategories(
          subCategoryResponse.data.subcategories.filter(
            (item) =>
              item.categoryid == response.data?.product?._doc?.categoryids[0]
          )
        );
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const statusResponse = await GetProductStatus(
          localStorage.getItem("accessToken")
        );
        setStatusData(statusResponse.data);
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  const fetchTags = async (pageToFetch = 1, searchTerm = "", reset = false) => {
    try {
      const tagResponse = await getAllTags(
        pageToFetch,
        itemsPerPage,
        searchTerm,
        localStorage.getItem("accessToken")
      );

      const fetchedTags = tagResponse.data.tags.items.map(tag => ({
        label: tag.title,
        value: tag.title
      }));

      setHasMore(fetchedTags.length === itemsPerPage);

      if (reset) {
        setAllTags(fetchedTags);
        setPage(2);
      } else {
        setAllTags(prev => [...prev, ...fetchedTags]);
        setPage(prev => prev + 1);
      }
    } catch (error) {
      console.error("Error fetching tags:", error);
    }
  };

  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(this, args), delay);
    };
  };

  const handleSearchChange = debounce((inputValue) => {
    setSearch(inputValue);
    fetchTags(1, inputValue, true); // reset = true
  }, 300);

  const handleScrollToBottom = () => {
    if (hasMore) {
      fetchTags(page, search);
    }
  };
  useEffect(() => {
    fetchTags(1, "", true);
  }, []);

  const customStyles = {
    control: (base, state) => ({
      ...base,
      boxShadow: "none",
      border: "none",
      backgroundColor: "#fff", // Optional: or transparent
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999, // To prevent it from hiding behind modals or dialogs
    }),
  };

  const handleNameChange = (e) => {
    const temp = { ...editedProductData };
    temp._doc.name = e.target.value;
    setEditedProductData(temp);
  };

  const handleWeightChange = (e) => {
    const temp = { ...editedProductData };
    temp._doc.weight = e.target.value;
    setEditedProductData(temp);
  };

  const handleCategoryIdChange = (e) => {
    const temp = { ...editedProductData };
    temp._doc.categoryids = [e.target.value];
    temp._doc.subcategoryids = [""];
    setEditedProductData(temp);
    setVisibleSubcategories(
      subcategories.filter((item) => item.categoryid === e.target.value)
    );
  };

  const handleSubcategoryIdChange = (e) => {
    const temp = { ...editedProductData };
    temp._doc.subcategoryids = [e.target.value];
    setEditedProductData(temp);
  };

  const handleJioMartIdChange = (e) => {
    const temp = { ...editedProductData };
    temp._doc.jiomartid = e.target.value;
    setEditedProductData(temp);
  };

  const handleBigbasketIdChange = (e) => {
    const temp = { ...editedProductData };
    temp._doc.bigbasketid = e.target.value;
    setEditedProductData(temp);
  };

  const handleBlinkitIdChange = (e) => {
    const temp = { ...editedProductData };
    temp._doc.blinkitid = e.target.value;
    setEditedProductData(temp);
  };

  const handleZeptoIdChange = (e) => {
    const temp = { ...editedProductData };
    temp._doc.zeptoid = e.target.value;
    setEditedProductData(temp);
  };
  const handleSwiggyInstamartIdChange = (e) => {
    const temp = { ...editedProductData };
    temp._doc.swiggyinstamartid = e.target.value;
    setEditedProductData(temp);
  };

  const handleDMartIdChange = (e) => {
    const temp = { ...editedProductData };
    temp._doc.dmartid = e.target.value;
    setEditedProductData(temp);
  };

  const handledescriptionChange = (e) => {
    const temp = { ...editedProductData };
    temp._doc.description = e.target.value;
    setEditedProductData(temp);
  };
  const handleAmazonIdChange = (e) => {
    const temp = { ...editedProductData };
    temp._doc.amazonid = e.target.value;
    setEditedProductData(temp);
  };
  const handledmartWeightChange = (e) => {
    const temp = { ...editedProductData };
    temp._doc.dmartweight = e.target.value;
    setEditedProductData(temp);
  };
  const handleFlipkartIdChange = (e) => {
    const temp = { ...editedProductData };
    temp._doc.flipkartid = e.target.value;
    setEditedProductData(temp);
  };
  const handleJiomartUrlChange = (e) => {
    const temp = { ...editedProductData };
    temp._doc.jiomarturl = e.target.value;
    setEditedProductData(temp);
  };

  const handleImageURLChange = (e) => {
    const temp = { ...editedProductData };
    temp._doc.imageurl = e.target.value;
    setEditedProductData(temp);
  };

  const handleIsExoticProductChange = (e) => {
    const temp = { ...editedProductData };
    temp._doc.isexoticproduct = e.target.value;
    setEditedProductData(temp);
  };
  const handleSelectedBrandChange = (e) => {
    const temp = { ...editedProductData };
    temp._doc.brandname = e.target.value;
    console.log("temp._doc.brandname", temp._doc.brandname);
    setEditedProductData(temp);
  };
  const handleSelectedTagChange = (selectedOptions) => {
    const updatedTags = selectedOptions.map(option => option.value);

    setEditedProductData(prev => ({
      ...prev,
      _doc: {
        ...prev._doc,
        tag: updatedTags,
      }
    }));
  };

  const handleIsLastMinuteAddonChange = (e) => {
    const temp = { ...editedProductData };
    temp._doc.islastminuteaddon = e.target.value;
    setEditedProductData(temp);
  };
  const handleIsPopularProductChange = (e) => {
    const temp = { ...editedProductData };
    temp._doc.isPopularProduct = e.target.value;
    setEditedProductData(temp);
  };
  const handleSwiggyWeight = (e) => {
    const temp = { ...editedProductData };
    temp._doc.swiggyweight = e.target.value;
    setEditedProductData(temp);
  };

  const handleDiscardClick = async () => {
    const temp = { ...productData };
    setEditedProductData(temp);
  };

  // const handleStatusChange = (e) => {
  //   const temp = { ...editedCategoryData };
  //   temp.statusid = e.target.value;
  //   setEditedCategoryData(temp);
  // };

  const validateInput = () => {
    if (editedProductData._doc.name === "")
      throw new Error("Product Name is required");
    if (editedProductData._doc.weight === "")
      throw new Error("Product Weight is required");
    //if(!(/^\d+(\.\d+)?$/).test(editedProductData._doc.weight))
    //  throw new Error("Invalid Product Weight.");
    if (editedProductData._doc.categoryids[0] === "")
      throw new Error("Category is required.");
    if (editedProductData._doc.subcategoryids[0] === "")
      throw new Error("Subcategory is required.");
    if (editedProductData._doc.imageurl === "")
      throw new Error("Image URL is required.");
  };

  const handleSubmitClick = async (e) => {
    e.preventDefault();

    try {
      validateInput();
    } catch (error) {
      setIsMessageRed(true);
      setMessage(error.message);
      window.scrollTo(0, 0);
      return;
    }

    let response;
    const requestBody = {
      name: editedProductData._doc.name,
      productid: editedProductData._doc.productid,
      weight: editedProductData._doc.weight,
      categoryids: editedProductData._doc.categoryids,
      subcategoryids: editedProductData._doc.subcategoryids,
      jiomartid: editedProductData._doc.jiomartid,
      blinkitid: editedProductData._doc.blinkitid,
      bigbasketid: editedProductData._doc.bigbasketid,
      zeptoid: editedProductData._doc.zeptoid,
      amazonid: editedProductData._doc.amazonid,
      swiggyinstamartid: editedProductData._doc.swiggyinstamartid,
      dmartid: editedProductData._doc.dmartid,
      description: editedProductData._doc.description,
      flipkartid: editedProductData._doc.flipkartid,
      imageurl: editedProductData._doc.imageurl,
      islastminuteaddon: editedProductData._doc.islastminuteaddon,
      isexoticproduct: editedProductData._doc.isexoticproduct,
      isbestsellers: editedProductData._doc.isbestsellers,
      ishotdeals: editedProductData._doc.ishotdeals,
      istrendinginyourarea: editedProductData._doc.istrendinginyourarea,
      istrendingoffers: editedProductData._doc.istrendingoffers,
      ishealthysnacking: editedProductData._doc.ishealthysnacking,
      isbestsellerstitle: editedProductData._doc.isbestsellerstitle,
      swiggyweight: editedProductData._doc.swiggyweight,
      brandname: editedProductData._doc.brandname,
      tags: editedProductData._doc.tag,
      isPopularProduct: editedProductData._doc.isPopularProduct,
    };
    console.log("requestBody??", requestBody);
    try {
      response = await UpdateProduct(
        requestBody,
        localStorage.getItem("accessToken")
      );
      if (response.status === 200) {
        setCategoryViewMessage(response.data.message);
        navigate("/product");
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        setIsMessageRed(true);
        setMessage(err.response.data.error);
        window.scrollTo(0, 0);
      } else {
        setIsMessageRed(true);
        setMessage("An error occurred. Please try again later.");
        window.scrollTo(0, 0);
      }
      console.log(err);
    }
  };

  console.log("Edited Product", editedProductData);
  return (
    <div className="dashboard-content">
      <Sidebar />
      {/* <div className="mobileOption d-flex align-items-center justify-content-between">
          <div  className="buyMore">
            <img className="img-fluid" src={logoImg} alt=""/>
          </div>
          <button className="btn btn-primary offCanvasToggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling"><Icon className="menu" icon={menu} size={25}/></button>
        </div> */}
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">Edit Product</h1>
          <div className="d-inline-flex gap-2">
            <NavLink to="/product" className="btn btn-primary">
              View All
            </NavLink>
          </div>
        </div>

        {message && (
          <div
            style={{ color: isMessageRed ? "red" : "black" }}
            className="alert alert-primary"
            role="alert"
          >
            {message}
          </div>
        )}

        <div
          role="tabpanel"
          className="personal-info tab-pane active storetab"
          id="pi"
        >
          {/* <h4 className="text-primary h6 fw-bold mb-3">Product main category information</h4> */}
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              {/* <div className="form-floating mb-4"> */}
              {/* <label htmlFor="catName">Name</label>
              <input
                type="text"
                value={editedProductData?._doc?.name}
                onChange={handleNameChange}
                className="form-control custom-input"
                id="catName"
                placeholder="Name"
              /> */}

              <label htmlFor="floatingInput">Select Brand</label>
              <select
                value={editedProductData?._doc?.brandname}
                onChange={handleSelectedBrandChange}
                className="form-select custom-input"
                id="brandSelect"
              >
                <option value="">Select a Brand</option>
                {brands.map((brand) => (
                  <option key={brand._id} value={brand.brandname}>
                    {brand.brandname}
                  </option>
                ))}
              </select>

              {/* </div> */}
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="catName">Product Name</label>
              <input
                type="text"
                value={editedProductData?._doc?.name}
                onChange={handleNameChange}
                className="form-control custom-input"
                id="catName"
                placeholder="Name"
              />
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="catName">Product Weight</label>
              <input
                type="text"
                value={editedProductData?._doc?.weight}
                onChange={handleWeightChange}
                className="form-control custom-input"
                id="catName"
                placeholder="Weight"
              />
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="floatingInput">Image URL</label>
              <input
                type="text"
                value={editedProductData?._doc?.imageurl}
                onChange={handleImageURLChange}
                className="form-control custom-input"
                id="floatingPassword"
                placeholder="Image URL"
              />
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              {/* <div className="form-floating"> */}
              <label htmlFor="floatingInput">Category</label>
              <select
                className="form-select custom-input"
                value={editedProductData?._doc?.categoryids[0]}
                onChange={handleCategoryIdChange}
              >
                {categories?.map((item) => (
                  <option value={item.categoryid}>{item.name}</option>
                ))}
              </select>
              {/* </div> */}
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              {/* <div className="form-floating"> */}
              <label htmlFor="floatingInput">Sub Category</label>
              <select
                className="form-select custom-input"
                value={editedProductData?._doc?.subcategoryids[0]}
                onChange={handleSubcategoryIdChange}
              >
                <option value="">Select a subcategory</option>
                {visibleSubcategories?.map((item) => (
                  <option value={item.subcategoryid}>{item.name}</option>
                ))}
              </select>
              {/* </div> */}
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              {/* <div className="form-floating mb-4"> */}
              <label htmlFor="floatingInput">Jio Mart ID</label>
              <input
                type="text"
                value={editedProductData?._doc?.jiomartid}
                onChange={handleJioMartIdChange}
                className="form-control custom-input"
                id="floatingPassword"
                placeholder="Jio Mart ID"
              />
              {/* </div> */}
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              {/* <div className="form-floating mb-4"> */}
              <label htmlFor="floatingInput">Blinkit ID</label>
              <input
                type="text"
                value={editedProductData?._doc?.blinkitid}
                onChange={handleBlinkitIdChange}
                className="form-control custom-input"
                id="floatingPassword"
                placeholder="Blinkit ID"
              />
              {/* </div> */}
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              {/* <div className="form-floating mb-4"> */}
              <label htmlFor="floatingInput">Bigbasket ID</label>
              <input
                type="text"
                value={editedProductData?._doc?.bigbasketid}
                onChange={handleBigbasketIdChange}
                className="form-control custom-input"
                id="floatingPassword"
                placeholder="Bigbasket ID"
              />
              {/* </div> */}
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              {/* <div className="form-floating mb-4"> */}
              <label htmlFor="floatingInput">Zepto ID</label>
              <input
                type="text"
                value={editedProductData?._doc?.zeptoid}
                onChange={handleZeptoIdChange}
                className="form-control custom-input"
                id="floatingPassword"
                placeholder="Zepto ID"
              />
              {/* </div> */}
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              {/* <div className="form-floating mb-4"> */}
              <label htmlFor="floatingInput">Swiggy InstaMart ID</label>
              <input
                type="text"
                value={editedProductData?._doc?.swiggyinstamartid}
                onChange={handleSwiggyInstamartIdChange}
                className="form-control custom-input"
                id="floatingPassword"
                placeholder="Swiggy InstaMart ID"
              />
              {/* </div> */}
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="floatingInput">Swiggy Weight</label>
              <input
                type="text"
                value={editedProductData?._doc?.swiggyweight}
                onChange={handleSwiggyWeight}
                className="form-control custom-input"
                id="floatingPassword"
                placeholder="swiggy weight"
              />
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              {/* <div className="form-floating mb-4"> */}
              <label htmlFor="floatingInput">Amazon Fresh URL</label>
              <input
                type="text"
                value={editedProductData?._doc?.amazonid}
                onChange={handleAmazonIdChange}
                className="form-control custom-input"
                id="floatingPassword"
                placeholder="Amazon Fresh URL"
              />
              {/* </div> */}
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              {/* <div className="form-floating mb-4"> */}
              <label htmlFor="floatingInput">Flipkart Grocery URL</label>
              <input
                type="text"
                value={editedProductData?._doc?.flipkartid}
                onChange={handleFlipkartIdChange}
                className="form-control custom-input"
                id="floatingPassword"
                placeholder="Flipkart Grocery URL"
              />
              {/* </div> */}
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              {/* <div className="form-floating mb-4"> */}
              <label htmlFor="floatingInput">Dmart Weight</label>
              <input
                type="text"
                value={editedProductData?._doc?.dmartweight}
                onChange={handledmartWeightChange}
                className="form-control custom-input"
                id="floatingPassword"
                placeholder="Dmart weight"
              />
              {/* </div> */}
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              {/* <div className="form-floating mb-4"> */}
              <label htmlFor="floatingInput">Jiomar Url</label>
              <input
                type="text"
                value={editedProductData?._doc?.jiomarturl}
                onChange={handleJiomartUrlChange}
                className="form-control custom-input"
                id="floatingPassword"
                placeholder="jiomartUrl"
              />
              {/* </div> */}
            </div>
          </div>

          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              {/* <div className="form-floating mb-4"> */}
              <label htmlFor="floatingInput">DMart URL</label>
              <input
                type="text"
                value={editedProductData?._doc?.dmartid}
                onChange={handleDMartIdChange}
                className="form-control custom-input"
                id="floatingPassword"
                placeholder="DMart Url"
              />
              {/* </div> */}
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">

              <label htmlFor="floatingInput">Popular Product</label>
              <select
                className="form-select custom-input"
                value={editedProductData?._doc?.isPopularProduct}
                onChange={handleIsPopularProductChange}
              >
                <option value={false}>False</option>
                <option value={true}>True</option>
              </select>

            </div>

            {/* <div className="form-group col-sm-12 col-lg-6 mb-3">
              
              <label htmlFor="floatingInput">Is Last Minute Addon?</label>
              <select
                className="form-select custom-input"
                value={editedProductData?._doc?.islastminuteaddon}
                onChange={handleIsLastMinuteAddonChange}
              >
                <option value={false}>False</option>
                <option value={true}>True</option>
              </select>
           
            </div> */}
          </div>

          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">

              <label htmlFor="floatingTextarea">Description</label>
              <textarea
                value={editedProductData?._doc?.description}
                onChange={handledescriptionChange}
                className="form-control custom-input"
                id="floatingTextarea"
                placeholder="Description"
              ></textarea>
            </div>

            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="floatingInput">Add Tag</label>
              <Select
                isMulti
                closeMenuOnSelect={false}
                options={allTags} // This should be [{ label: "Organic", value: "Organic" }, ...]
                value={editedProductData?._doc?.tag?.map(tag => ({
                  label: tag,
                  value: tag,
                }))}
                onChange={handleSelectedTagChange}
                placeholder="Select Tags"
                className="custom-select custom-input"
                onInputChange={handleSearchChange}
                onMenuScrollToBottom={handleScrollToBottom}
                isLoading={hasMore}
                styles={customStyles}
              />

            </div>
          </div>

          <div className="row">
            <div className="form-group col-sm-12 col-lg-12 mb-3">
              <button
                type="submit"
                onClick={handleDiscardClick}
                className="btn btn-danger save-btn text-uppercase px-4 my-3"
              >
                Discard
              </button>{" "}
              &nbsp;
              <button
                type="submit"
                onClick={handleSubmitClick}
                className="btn btn-primary save-btn text-uppercase px-4 my-3"
              >
                Save
              </button>
            </div>
          </div>
        </div>
        <hr />
      </div>
    </div>
  );
}
export default EditProduct;
